"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TelemetryEvent = exports.Telemetry = void 0;
const abstractmessage_1 = require("./abstractmessage");
class TelemetryEvent {
    constructor(start, // relative to event send time
    end, // relative to event send time
    title, details, id, // optional, default will be random assigned by backend
    type) {
        this.start = start;
        this.end = end;
        this.title = title;
        this.details = details;
        this.id = id;
        this.type = type;
    } // optional, default will be "SDK" assigned by backend
}
exports.TelemetryEvent = TelemetryEvent;
class Telemetry extends abstractmessage_1.AbstractMessage {
    constructor(events) {
        super();
        this.method = 'telemetry.v1';
        this.events = events;
    }
}
exports.Telemetry = Telemetry;
